/* global globalThis */
const STORAGE_KEY = 'rv_client_device';
let fallbackId;

export function clientDeviceId() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(saved || '')) return saved;
  } catch { /* A stable in-memory ID still works when storage is restricted. */ }
  if (!fallbackId) {
    const bytes = new Uint8Array(16); globalThis.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, n => n.toString(16).padStart(2, '0')).join('');
    fallbackId = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  try { localStorage.setItem(STORAGE_KEY, fallbackId); } catch { /* Keep memory fallback. */ }
  return fallbackId;
}

export function clientDeviceType(device = globalThis.navigator) {
  const ua = device?.userAgent || '';
  return /android|iphone|ipad|ipod|mobile/i.test(ua) ||
    (/macintosh/i.test(ua) && device?.maxTouchPoints > 1) ? 'mobile' : 'desktop';
}
